import { withApollo, graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import ChangePassword from './index';

const changePasswordMutation = gql`
  mutation MyChangePassword($userChangePassword: UserChangePassword!) {
    changePassword(userChangePassword: $userChangePassword) {
      success
      message
    }
  }
`;

let ChangePasswordWithData = withApollo(
  compose(
    graphql(changePasswordMutation, {
      props({ ownProps, mutate }) {
        return {
          changePassword: (oldPassword, newPassword) => {
            return mutate({
              variables: {
                userChangePassword: {
                  oldPassword: oldPassword,
                  newPassword: newPassword
                }
              }
            });
          }
        };
      },
      options: {
        errorPolicy: 'all'
      }
    })
  )(ChangePassword)
);

export default ChangePasswordWithData;



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePasswordWithData.js